import * as Cookies from "js-cookie";
import React from 'react';

const modeloSessionUser = {
  id:0,
  nome: "",
  login: "",
  password: "",
  estabelecimentoId: 0,
  estabelecimentoDescricao: "",
  tipoPerfil: 0, // Master - 0 / Estabelecimento - 1 / Profissional - 2 / Cliente - 3 / Matriz - 4
  fraquiaId: 0,
  fraquiaDescricao: "",
};

export const setSessionCookie = (session) => {
  Cookies.remove("session");
  Cookies.set("session", session, { expires: 0.08 });
};

export const getSessionCookie = () => {
  const sessionCookie = Cookies.get("session");
  if (sessionCookie === undefined) {
    return null;
  } else {
    return JSON.parse(sessionCookie);
  }
};

export const SessionContext = React.createContext(getSessionCookie());

/*** TOKEN ***/

export const setTokenCookie = (token) => {
  Cookies.remove("token");
  Cookies.set("token", token, { expires: 0.08 });
};

export const getTokenCookie = () => {
  const tokenCookie = Cookies.get("token");
  if (tokenCookie === undefined) {
    return null;
  } else {
    return JSON.parse(tokenCookie);
  }
};

export const TokenContext = React.createContext(getTokenCookie());

/*** Language ***/

export const setLanguageCookie = (language) => {
  Cookies.remove("language");
  Cookies.set("language", language, { expires: 0.08 });
};

export const getLanguageCookie = () => {
  const languageCookie = Cookies.get("language");
  if (languageCookie === undefined) {
    return null;
  } else {
    return JSON.parse(languageCookie);
  }
};

export const getLanguageSelected = ()=> {
  const languageCookie = getLanguageCookie();
    var language = 'pt';
    if(languageCookie)
        language =languageCookie.language;
  return language;
}

